import { h } from '@stencil/core';
import { pesIconSizes } from '@pes-ui/utils';
export class CommerceConnectorNoResult {
  constructor() {
    this.label = undefined;
  }
  render() {
    return (h("div", { class: "cc-no-result" }, h("div", { class: "cc-no-result__icon" }, h("pes-icon", { size: pesIconSizes.XLARGE }, "action_ban")), h("div", { class: "cc-no-result__label" }, this.label)));
  }
  static get is() { return "pes-cc-no-result"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["no-result.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["no-result.css"]
    };
  }
  static get properties() {
    return {
      "label": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "string",
          "resolved": "string",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "label",
        "reflect": false
      }
    };
  }
}
